<template>
  <div class="share-page">
    <navigation :theme="{ background: 'none', color: '#fff', }" arrTheme='white'>
      <span>邀请有奖</span>
      <span slot="right" class="rule-txt" @click="$router.push({ path: '/actvie/share/rule' })" data-sensors-click>活动规则</span>
    </navigation>

    <div class="header"></div>

    <div class="rule-content">
      <div class="title"><span class="red">每</span>邀请1人，您可<span class="red">赚{{total}}元</span></div>
      <div class="fl-container">
        <div class="item">
          <div class="num"><i>¥</i><span>{{ detail.awardLoanAmount }}</span></div>
          <p>福利一</p>
        </div>
        <div class="add"></div>
        <div class="item">
          <div class="num"><i>¥</i><span>{{ detail.awardBrowseAmount }}</span></div>
          <p>福利二</p>
        </div>
      </div>
      <div class="btn" @click="getShareCode" data-sensors-click>
        <img class="animation-btn" v-if="detail.activeStatus=='ACTIVE'" src="./images/btn_yaoqing@2x.png">
        <img v-else src="./images/btn_jieshu@2x.png">
      </div>
      <router-link to="/actvie/share/list" class="share-list" data-sensors-click>查看邀请明细</router-link>
    </div>

    <div class="step-info"></div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { copyToClipbord } from '@/assets/utils'
export default {
  data () {
    return {
      pending: false,
      detail: {
        activeStatus: '',
        awardBrowseAmount: 0,
        awardLoanAmount: 0
      }
    }
  },
  mounted () {
    this.getOwnActiveDetail()
    this.$bus.$emit('ready')
  },
  computed: {
    total () {
      return this.detail.awardBrowseAmount * 1 + this.detail.awardLoanAmount * 1
    }
  },
  methods: {
    ...mapActions('share', ['ownActiveDetail', 'ownActiveShareCode']),
    async getOwnActiveDetail () {
      const { success, data } = await this.ownActiveDetail()
      if (success) {
        this.detail = data
      }
    },
    // 拷贝微信
    copy ({ shareTitle, shareUrl }) {
      copyToClipbord(`${shareTitle},${shareUrl}`)
      this.$message('分享链接已复制至剪切板，赶快去邀请好友吧')
    },
    async getShareCode () {
      if (this.detail.activeStatus !== 'ACTIVE') return
      if (this.pending) return
      this.pending = true
      const { success, data } = await this.ownActiveShareCode()
      this.pending = false
      if (success) {
        this.copy(data)
      }
    }
  }
}

</script>
<style lang='less' scoped>
@import "../../../assets/less/mixin.less";

.share-page {
  background: linear-gradient(180deg, #FB2920 0%, #FDCE99 30%, #FD8D7A 80%, #FD4642 100%);
  min-height: 100vh;
  padding-bottom: 66px;
  width: 10rem;
  overflow: hidden;

  .header {
    height: 174px;
    background: url(./images/title@2x.png) no-repeat center center/ 100% 100%;
    margin-top: 36px;
  }
  .step-info {
    margin:10px auto 0;
    height: 370px;
    width: 670px;
    background: url(./images/img_sanbu@2x.png) no-repeat center center/ 100% 100%;
  }
  .rule-content {
    height: 762px;
    background: url(./images/img_a@2x.png) no-repeat center center/ 100% 100%;
    position: relative;
    

    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 40px;
      color: #943001;
      line-height: 56px;
      text-align: center;
      padding-top: 20px;

      span {
        color: #E10B00;
      }
    }
    .btn {
      width:600px;
      height:150px;
      margin: 130px auto 0;
      >img {
        width: 100%;
      }
      .animation-btn {
        animation: abtn .3s infinite alternate ;

      }
      @keyframes abtn {
        from {
          transform: scale(0.90);
        }
      }
    }
    .share-list {
      display: block;
      text-align: center;
      color: #fff;
      text-decoration: underline;
      font-size: 28px;
    }
    .fl-container {
      display: flex;
      justify-content: center;
      gap: 25px;
      align-items: center;
      margin-top: 54px;

      

      .item {
        width: 240px;
        height: 200px;
        background: url('./images/img_jiekuan@2x.png') no-repeat center center / 100% 166px;

        .num {
          text-align: center;
          color: #E10B00;
          font-family: DIN, DIN;
          padding-top: 15px;

          i {
            font-size: 32px;
            font-style: normal;
          }

          span {
            font-family: DIN, DIN;
            font-weight: 500;
            font-size: 90px;
          }
        }

        p {
          color: #fff;
          font-size: 24px;
          color: #943001;
          text-align: center;
          padding-top: 50px;
        }
      }

      .item:last-child {
        background-image: url('./images/img_liulan.png')
      }

      .add {
        width: 32px;
        height: 32px;
        background: url(./images/img_jiahao@2x.png) no-repeat center center / 100% 100%;
      }
    }
  }

  .rule-txt {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    color: #ffffff;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    margin-right: 40px;
    display: block;
  }

}
</style>